import PropTypes from 'prop-types';

import AsyncTableComponent from '../Table/AsyncTableContainer';

import CheckmarkOrXComponent from '../Table/CheckmarkOrXComponent';

import { formatDate } from '../../utils';
import { getFullName } from '../Person/utils';
import { getExportTitle } from '../ViewExport/utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';

import { TABLE_DATA_TYPES, fullTimeDateFormat } from '../../staticData';
import CellPersonWithImage from '../Table/CellPersonWithImage';
import { limitFilter } from '../Table/filters';
import RemoteDoormanAgentsListExport from './RemoteDoormanAgentsListExport';

const RemoteDoormanAgentsListComponent = (props) => {
  const { onLoad, items, getItems, listParams, listKey, onExport } = props;

  const columns = [
    {
      Header: 'Agent Name',
      id: 'name',
      headerClassName: 'sort',
      accessor: ({ name }) => name,
    },
    {
      Header: 'Person Name',
      id: 'person',
      headerClassName: 'sort',
      accessor: ({ person }, isExport) => {
        if (isExport) return getFullName(person);
        const linkUrl = `/global-person-search/${person?.id}`;
        return <CellPersonWithImage person={person} linkUrl={linkUrl} />;
      },
    },
    {
      Header: 'Created At',
      id: 'created_at',
      headerClassName: 'sort',
      defaultSortDesc: true,
      accessor: ({ createdAt }) =>
        formatDate(createdAt, true, fullTimeDateFormat),
    },
    {
      Header: 'Status',
      id: 'status',
      sortable: false,
      accessor: ({ status }) => status || 'N/A',
    },
    {
      Header: 'Is Demo?',
      id: 'is_demo',
      headerClassName: 'sort',
      accessor: ({ isDemo }, isExport) =>
        isExport ? String(isDemo) : <CheckmarkOrXComponent value={isDemo} />,
    },
    {
      Header: 'Average Pickup Time',
      id: 'avgPickupTime',
      sortable: false,
      accessor: ({ statistics }) => statistics?.avgPickupTime || 'N/A',
    },
    {
      Header: 'Average Call Time',
      id: 'avgCallTime',
      sortable: false,
      accessor: ({ statistics }) => statistics?.avgCallTime || 'N/A',
    },
    {
      Header: 'Percent Not Handled',
      id: 'avgPercentNotHandled',
      sortable: false,
      accessor: ({ statistics }) => statistics?.avgPercentNotHandled || 'N/A',
    },
  ];

  const filters = [limitFilter(listParams)];

  const defaultParams = {
    offset: '0',
  };

  const action = null;
  const fieldsForBackendSort = [TABLE_CONSTANTS.created_at];
  const tableDataType = TABLE_DATA_TYPES.items;

  const title = 'Remote Doorman Agents List';
  const exportTitle = getExportTitle(title);
  const exportActions = (
    <RemoteDoormanAgentsListExport
      title={exportTitle}
      getDataForExport={onExport}
      columns={columns}
    />
  );

  return (
    <AsyncTableComponent
      tableId={TABLE_ID.remoteDoormanAgentsList}
      title={title}
      columns={columns}
      defaultSort={TABLE_CONSTANTS.created_at}
      fieldsForBackendSort={fieldsForBackendSort}
      filters={filters}
      showFiltersAreApplied={false}
      onLoad={onLoad}
      items={items}
      getItems={getItems}
      listParams={listParams}
      defaultParams={defaultParams}
      tableDataType={tableDataType}
      listKey={listKey}
      action={action}
      manual
      defaultSortDesc
      exportActions={exportActions}
      isHideSearch
    />
  );
};

RemoteDoormanAgentsListComponent.propTypes = {
  onLoad: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  items: PropTypes.instanceOf(Object).isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  listKey: PropTypes.string.isRequired,
  onExport: PropTypes.func.isRequired,
};

export default RemoteDoormanAgentsListComponent;
